import axios from "axios";
import { Capacitor } from "@capacitor/core";

/**
 * Interceptor global de Axios para:
 * 1. Reemplazar localhost por 10.0.2.2 en Android
 * 2. Agregar automáticamente el token de autenticación a todas las peticiones
 * Este interceptor se aplica a TODAS las peticiones axios automáticamente
 */
export function setupAxiosInterceptor() {
  // Interceptor de request: modifica la URL y agrega headers antes de enviar la petición
  axios.interceptors.request.use(
    (config) => {
      // 1. Reemplazar localhost por 10.0.2.2 si estamos en Android/iOS
      if (Capacitor.isNativePlatform()) {
        // Reemplazar localhost en la URL completa
        if (config.url) {
          config.url = config.url
            .replace(/http:\/\/localhost:(\d+)/g, 'http://10.0.2.2:$1')
            .replace(/https:\/\/localhost:(\d+)/g, 'https://10.0.2.2:$1');
        }
        
        // También reemplazar en baseURL si existe
        if (config.baseURL) {
          config.baseURL = config.baseURL
            .replace(/http:\/\/localhost:(\d+)/g, 'http://10.0.2.2:$1')
            .replace(/https:\/\/localhost:(\d+)/g, 'https://10.0.2.2:$1');
        }
      }
      
      // 2. Agregar token de autenticación automáticamente si existe
      // Solo agregar si no está ya presente en los headers
      if (!config.headers.Authorization) {
        const token = localStorage.getItem("token");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        } else {
          // Log para debug: solo en desarrollo
          if (import.meta.env.DEV) {
            console.warn(`[Axios Interceptor] No token found for request to: ${config.url || config.baseURL}`);
          }
        }
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Interceptor de response: manejar errores 401 (Unauthorized)
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Si recibimos un 401, el token podría ser inválido o expirado
      if (error.response && error.response.status === 401) {
        console.warn("401 Unauthorized - Token inválido o expirado");
        // No hacer logout automático aquí porque podría ser un login fallido
        // El componente que maneja el login debe decidir qué hacer
      }
      return Promise.reject(error);
    }
  );
}
